import * as v from 'valibot';

export const UserSchema = v.object({
  email: v.nullish(v.string()),
  firstname: v.nullish(v.string()),
  lastname: v.nullish(v.string()),
  locale: v.nullish(v.string()),
  passwordResetPossible: v.nullish(v.boolean()),
  userId: v.nullish(v.number()),
  customFields: v.nullish(v.record(v.string(), v.unknown())),
});

export type TUser = v.Output<typeof UserSchema>;
